export default __webpack_public_path__ + "static/media/CUBUS_10.0.71132298.png";